export const containerStyle = {
  padding: 40,
  background: '#eef2ff',
  minHeight: '100vh',
};

export const headerRowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 0',
  marginTop: 30,
};

export const titleStyle = {
  margin: 0,
  fontWeight: 600,
  fontSize: '20px',
  color: '#002f6c',
};

export const addButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 20px',
  background: '#42A5F5',
  color: 'white',
  border: 'none',
  borderRadius: '20px',
  fontSize: '14px',
  cursor: 'pointer',
  fontWeight: 500,
  boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
};

export const addSymbolStyle = {
  fontSize: '20px',
  lineHeight: 0,
};
